import createCachedSelector from 're-reselect';

const getMyself = ({ myself }) => myself;
const getItemId = (state, { itemId }) => itemId;
const cacheKey = (state, props) => `${getItemId(state, props)}`;

const inputs = [getMyself, getItemId];
const output = (myself, itemId) => myself.qualities.find(q => q.id === itemId);

export default createCachedSelector(inputs, output)(cacheKey);
